import React from "react";
import { siteContent } from "../content";
const website = siteContent.projectWebsite;

const ProjectWebsite = () => {
  return (
    <div className="mt-10">
      <div className="container py-20">
        <h1 className="text-center font-bold text-4xl text-slate-800 pb-10">
          {website.title}
        </h1>
        <div className="text-center">
          <a href={website.link} target="_blank" rel="noreferrer">
            <div className="shadow-md border border-slate-50 inline-block p-5 round hover:bg-greenish hover:border-greenish hover:text-white hover:shadow-lg transition-all duration-300">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-6 w-6 inline-block align-middle mr-1"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth={2}
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
                />
              </svg>
              {website.link}
            </div>
          </a>
        </div>
      </div>
    </div>
  );
};

export default ProjectWebsite;
